export const nullableString = (value: any) => {
    if (typeof value === 'undefined' || value === null || value === '' || value === 'null') return '-';

    return value;
}
